/**
 * User Account API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminShareRequestFilterDto { 
    deviceIds?: Array<number>;
    shareableTypes?: Array<AdminShareRequestFilterDto.ShareableTypesEnum>;
    requestedByUserAccountIds?: Array<number>;
    vectronicOnly?: boolean;
}
export namespace AdminShareRequestFilterDto {
    export const ShareableTypesEnum = {
        Animal: 'Animal',
        Camera: 'Camera',
        Collar: 'Collar',
        ConfigurationDevice: 'ConfigurationDevice',
        DataLogger: 'DataLogger',
        DropOff: 'DropOff',
        ExternalSensor: 'ExternalSensor',
        Trap: 'Trap',
        Tt4Sensor: 'TT4Sensor'
    } as const;
    export type ShareableTypesEnum = typeof ShareableTypesEnum[keyof typeof ShareableTypesEnum];
}


export type ShareableTypesEnum = typeof AdminShareRequestFilterDto.ShareableTypesEnum[keyof typeof AdminShareRequestFilterDto.ShareableTypesEnum];
